<template>
    <canvas ref="historyChart" id="historyChart"></canvas>
</template>

<script>
import DbService from "../services/apiService";
import ChartJs from "chart.js";
import moment from "moment";
import "chartjs-plugin-crosshair";

export default {
    name: "TotalDataGraph",
    props: {
        date: String
    },
    data: function() {
        return {
            lineChart: null,
            dbService: new DbService()
        };
    },
    methods: {
        updateData(date) {
            const self = this;

            const addDataPoint = (xValue, yValue) => {
                this.$data.lineChart.data.datasets[0].data.push({
                    x: xValue,
                    y: yValue
                });
            };

            this.$data.lineChart.data.datasets[0].data.length = 0;

            let dayToDisplay = moment();
            if (date) {
                dayToDisplay = moment(date);
            }

            const startOfDayToDisplay = dayToDisplay.startOf("day").toDate();
            const startOfNextDayToDisplay = dayToDisplay.add(1, "day").toDate();

            this.$data.dbService
                .getAllData()
                .where("zeit", ">=", startOfDayToDisplay)
                .where("zeit", "<", startOfNextDayToDisplay)
                .orderBy("zeit", "asc")
                .onSnapshot(querySnapshot => {
                    querySnapshot.docChanges().forEach(change => {
                        if (change.type !== "added") return;

                        if (this.$data.lineChart.data.datasets[0].data.length >= 288)
                            this.$data.lineChart.data.datasets[0].data.shift();

                        const data = change.doc.data();
                        addDataPoint(moment.unix(data.zeit.seconds), parseInt(data.aktuelleLeistung));
                        this.$data.lineChart.update();

                        self.$emit("update", data);
                    });
                });
        }
    },
    watch: {
        date: function(date) {
            this.updateData(date);
        }
    },
    mounted() {
        this.$data.lineChart = new ChartJs("historyChart", {
            type: "line",
            data: {
                labels: [],
                datasets: [
                    {
                        label: "Leistung (W)",
                        data: [],
                        borderColor: "#382dd7",
                        fill: false,
                        pointRadius: 0,
                        // pointHitRadius: 1,
                        borderWidth: 2
                    }
                ]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                    xAxes: [
                        {
                            type: "time",
                            distribution: "linear",
                            ticks: {
                                autoSkip: true,
                                source: "data",
                                maxTicksLimit: 5
                            },
                            time: {
                                displayFormats: {
                                    millisecond: "H:mm:ss",
                                    second: "H:mm:ss",
                                    minute: "H:mm",
                                    hour: "H:mm",
                                    day: "YYYY-MM-DD H:mm"
                                }
                            }
                        }
                    ]
                },

                plugins: {
                    crosshair: {
                        sync: {
                            enabled: false
                        }
                    }
                },
                tooltips: {
                    mode: "index",
                    intersect: false
                }
            }
        });

        this.updateData(this.date);
    }
};
</script>

<style scoped>
.spinner {
    position: absolute;
    top: 50%;
}
</style>
